import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function BellIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "13"}
      height={height || "14.857"}
      viewBox="0 0 13 14.857"
    >
      <path
        id="Path_10205"
        data-name="Path 10205"
        d="M12.75,11.013c-.561-.6-1.61-1.509-1.61-4.477a4.582,4.582,0,0,0-3.713-4.5v-.6a.928.928,0,1,0-1.856,0v.6a4.582,4.582,0,0,0-3.713,4.5C1.859,9.5.81,10.41.25,11.013a.907.907,0,0,0-.25.63.929.929,0,0,0,.931.929H12.068A.929.929,0,0,0,13,11.643.906.906,0,0,0,12.75,11.013ZM1.96,11.179A7.267,7.267,0,0,0,3.252,6.553c0-.006,0-.011,0-.017a3.25,3.25,0,0,1,6.5,0c0,.006,0,.011,0,.017a7.265,7.265,0,0,0,1.292,4.626ZM6.5,15.357A1.857,1.857,0,0,0,8.356,13.5H4.644A1.857,1.857,0,0,0,6.5,15.357Z"
        transform="translate(0 -0.5)"
        fill={color || "#2f2f2f"}
      />
    </svg>
  );
}
